module.exports = __webpack_public_path__ + "static/media/recanto.6644e977.jpg";